import { ConfirmDialogIdentifier } from '../../../../../../../../shared/Confirm/actions'

export const SIGNATURE_DROP_DIALOG: ConfirmDialogIdentifier = 'SignatureDropDialog'
